<template>
  <shortcuts-panel
    v-if="!emptyData"
    shortcut-class-suffix="goals"
    :shortcuts-data="goalsShortcutData"
    @clickedLink="sendGoalShortcutEvent">
    <template v-slot:header>
      <h3>Goals, objectives, and progress monitoring assessments</h3>
    </template>
  </shortcuts-panel>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ShortcutsPanel from './ShortcutsPanel'

export default {
  name: 'GoalsShortcuts',
  components: {
    ShortcutsPanel
  },
  props: {
    altHeader: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState('presentlevels', {
      goalsShortcutData: state => {
        let rawData = state.goalsShortcutData

        return Object.keys(rawData).map(skillName => {
          return {
            heading: skillName,
            links: rawData[skillName].map(d => {
              return {
                linkText: d.subjectDomain,
                routeParams: { name: 'BrowseGoalsPage', query: d }
              }
            })
          }
        })
      },
      grade: state => state.enrolledGrade
    }),
    emptyData() {
      return Object.keys(this.goalsShortcutData).length === 0
    }
  },
  methods: {
    sendGoalShortcutEvent(shortcutPayload) {
      this.$sendEvent('Clicked Present Levels Goal Shortcut', {
        plw_goal_shortcut_subject: shortcutPayload.subject,
        plw_goal_shortcut_grades: shortcutPayload.grades,
        plw_goal_shortcut_instructional_level: shortcutPayload.instructionalLevel,
        plw_goal_shortcut_category: shortcutPayload.subjectDomain,
        source: 'shortcuts'
      })
    }
  }
}
</script>
